/**
 * @Description 选址地图详情分享按钮
 */

import { FC } from 'react';
import { Tooltip } from 'antd';
import { useMethods } from '@lhb/hook';
import { getShareId } from '@/common/api/common';
import { getCookie } from '@lhb/cache';
// import cs from 'classnames';
import styles from './index.module.less';
import IconFont from '@/common/components/IconFont';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import copy from 'copy-to-clipboard';
import { getSiteModelList } from '@/common/api/networkplan';
import dayjs from 'dayjs';
import { useCurrentUserInfo } from '@/common/hook/useCurrentUserInfo';
import { useSelector } from 'react-redux';

interface ShareProps {
  id: number;
  modelConfigId: number;
  globalAliasItemVOs: any;
  tenantInfo: any;
  // userInfo: any;
  userId: any;
  areaName?: string;
  rangeType?: any;
  // isSemirModel?: boolean; // 是否是森马模型
};

const Share: FC<ShareProps> = ({
  id,
  modelConfigId,
  globalAliasItemVOs = {},
  tenantInfo = {}, // 租户信息
  userId,
  areaName,
  rangeType,
  // isSemirModel = false,
}) => {
  const defaultConfig = useSelector((state: any) => state.youth.defaultConfig);
  const {
    /* 当前用户信息 */
    currentUserInfo,
  } = useCurrentUserInfo();
  const { standardChancePointReportLogo: reportLogo } = tenantInfo;

  const methods = useMethods({
    handleShare: async() => {
      let targetModelConfigId = modelConfigId;
      if (!targetModelConfigId || +targetModelConfigId <= 0) {
        const data = await getSiteModelList();
        targetModelConfigId = data[0]?.id || 0;
      }
      // 兜底，防止机会点所属商圈组件、新增商圈列表页在引用该详情时，没有配置选址地图模型
      if (!targetModelConfigId) {
        V2Message.warning(`请先配置选址地图模型！`);
        return;
      }
      const curTime = dayjs();
      // 和app分享统一链接，由原本的7天改为30天
      const failureTime = curTime.add(30, 'day').format('YYYY-MM-DD HH:mm:ss');
      const tenantId = getCookie('tenantId') || tenantInfo?.id;
      const employeeId = getCookie('employeeId') || userId;
      getShareId({
        // 和app分享统一链接
        longLinkUrl: `${process.env.CONSOLE_PC_URL}/share/youth`,
        content: JSON.stringify({
          id,
          modelConfigId: targetModelConfigId,
          tenantId,
          globalAliasItemVOs,
          reportLogo,
          employeeId,
          rangeType: rangeType,
          // isSemirModel,
          waterText: currentUserInfo.mobile ? `${currentUserInfo.name} ${currentUserInfo.mobile.slice(-4)}` : currentUserInfo.name,
          modelClusterInfo: !!defaultConfig?.modelClusterInfo,
        }),
        expirationDate: failureTime, // null代表永不失效
        expirationRedirectUrl: `${process.env.CONSOLE_PC_URL}/share/failure`,
        needToken: true,
      }).then((res: any) => {
        V2Message.success('链接已复制，可直接发送给你的朋友');
        // https://gitlab.lanhanba.com/fe/treasure/-/issues/102
        setTimeout(() => {
          copy(`${areaName}：${res.frontShareLinkUrl}`);
        }, 0);
      });
    }
  });
  return (
    <Tooltip title='分享'>
      <div className={styles.shareCon} onClick={methods.handleShare}>
        <IconFont iconHref='iconshare'/>
      </div>
    </Tooltip>

  );
};

export default Share;
